import {Container} from '@inlet/react-pixi';
import React from 'react';
import {Border, Rectangle} from '@gongxigames/framework/core/fragments/react';

type BackgroundWithHeadProps = {
    width: number;
    headHeight: number;
    bodyHeight: number;
    headFill: number;
    bodyFill: number;
    round?: number;
    border?: Border;
    titleEnabled: boolean;
};

type SystemPopupBackgroundProps = {
    width: number;
    bodyHeight: number;
    headHeight: number;
    titleEnabled: boolean;
};

export const SystemPopupBackground = (props: SystemPopupBackgroundProps): JSX.Element => {
    const {width, bodyHeight, headHeight, titleEnabled} = props;

    return <BackgroundWithHead
        width={width}
        headHeight={headHeight} bodyHeight={bodyHeight} headFill={0x252525} bodyFill={0x000000} border={{color: 0x252525, width: 5}}
        round={50}
        titleEnabled={titleEnabled}
    />;
};

const BackgroundWithHead = (props: BackgroundWithHeadProps): JSX.Element => {
    const {width, headHeight, bodyHeight, headFill, bodyFill, round = 0, border, titleEnabled} = props;

    return (
        <Container>
            {titleEnabled && <Rectangle width={width} height={headHeight} fill={headFill} round={[round, round, 0, 0]}/>}
            <Rectangle y={headHeight} width={width} height={bodyHeight} fill={bodyFill} round={[0, 0 , round, round]} />
            <Rectangle width={width} height={bodyHeight + headHeight} fill={0x00000} alpha={0} round={round} border={border} />
        </Container>
    );
};
